import React, { createContext, useContext, useReducer, useRef } from 'react';
import PropTypes from 'prop-types';

import { tableReducer, initialState } from '../store/tableReducer';

export const TableContext = createContext(null);
export const TableDispatchContext = createContext(null);
const TableRefsContext = createContext(null);
export const TableBoundaryContext = createContext(null);

export function TableProvider({ children }) {
  const [state, dispatch] = useReducer(tableReducer, initialState);
  const boundaryRef = useRef(null);

  return (
    <TableContext.Provider value={state}>
      <TableDispatchContext.Provider value={dispatch}>
        <TableBoundaryContext.Provider value={boundaryRef}>
          {children}
        </TableBoundaryContext.Provider>
      </TableDispatchContext.Provider>
    </TableContext.Provider>
  );
}

TableProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useTableState() {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error('useTableState must be used within TableProvider');
  }
  return context;
}

export function useTableDispatch() {
  const context = useContext(TableDispatchContext);
  if (!context) {
    throw new Error('useTableDispatch must be used within TableProvider');
  }
  return context;
}

export function useTableRefs() {
  const context = useContext(TableRefsContext);
  if (!context) {
    throw new Error('useTableRefs must be used within TableProvider');
  }
  return context;
}

// Add boundary context hook
export function useTableBoundary() {
  const context = useContext(TableBoundaryContext);
  if (!context) {
    throw new Error('useTableBoundary must be used within TableProvider');
  }
  return context;
}
